import { render, staticRenderFns } from "./gzzoc-hepatobiliary.vue?vue&type=template&id=8d2887f8&scoped=true&lang=pug&"
import script from "./gzzoc-hepatobiliary.vue?vue&type=script&lang=js&"
export * from "./gzzoc-hepatobiliary.vue?vue&type=script&lang=js&"
import style0 from "./gzzoc-hepatobiliary.vue?vue&type=style&index=0&id=8d2887f8&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d2887f8",
  null
  
)

export default component.exports